export default __webpack_public_path__ + "static/Pack-ebd8f54791adc0fbdfb80f709c40d2f8.png";